import { DELETE, GET, POST, PUT, omsBaseUrlApi, cpBaseUrl } from '@constants/generic-constants.js';
import NetworkManager from '../../services/network-service.js';
import { isCP } from '../../utils/app-utils.js';

const baseUrl = isCP() ? cpBaseUrl : omsBaseUrlApi;

export const createQuickLinkApi = (payload) => {
  return new Promise((resolve, reject) => {
    let url = `${baseUrl}/quick_links`;
    NetworkManager.performRequest(url, payload, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getQuickLinkApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${baseUrl}/quick_links${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const sortQuickLinkApi = (payload) => {
  return new Promise((resolve, reject) => {
    let url = `${baseUrl}/quick_links/sort`;
    NetworkManager.performRequest(url, payload, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteQuickLinkApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${baseUrl}/quick_links/${id}`;
    NetworkManager.performRequest(url, null, DELETE)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
